/** @format */

import { ProductReviewDrawerType, ProductReviewSlider } from '../../model';
import { createAction, props } from '@ngrx/store';

/**
 * Action types initialization
 */
export enum ProductReviewUiActionTypes {
	CLEAN_PRODUCT_REVIEW_SLIDER_INFO = '[Product Reviews Slider Ui] Clear Product Review Slider',
	CLOSE_PRODUCT_REVIEW_DRAWER = '[Product Reviews Ui] Close Product Review Drawer',
	CLOSE_PRODUCT_REVIEW_IMAGE_MODAL = '[Product Reviews Image Ui] Close Product Review Image Modal',
	OPEN_PRODUCT_REVIEW_DRAWER = '[Product Reviews Ui] Open Product Review Drawer',
	OPEN_PRODUCT_REVIEW_IMAGE_MODAL = '[Product Reviews Image Ui] Open Product Review Image Modal',
	SET_PRODUCT_REVIEW_SLIDER_INFO = '[Product Reviews Slider Ui] Set Product Review Slider'
}

/**
 * Actions initialization
 */
export const openProductReviewDrawer = createAction(
	ProductReviewUiActionTypes.OPEN_PRODUCT_REVIEW_DRAWER,
	props<{ drawerType: ProductReviewDrawerType }>()
);

export const closeProductReviewDrawer = createAction(
	ProductReviewUiActionTypes.CLOSE_PRODUCT_REVIEW_DRAWER
);

export const addSliderState = createAction(
	ProductReviewUiActionTypes.SET_PRODUCT_REVIEW_SLIDER_INFO,
	props<{ slider: ProductReviewSlider }>()
);

export const cleanSliderState = createAction(
	ProductReviewUiActionTypes.CLEAN_PRODUCT_REVIEW_SLIDER_INFO
);

export const openReviewImageModal = createAction(
	ProductReviewUiActionTypes.OPEN_PRODUCT_REVIEW_IMAGE_MODAL
);

export const closeReviewImageModal = createAction(
	ProductReviewUiActionTypes.CLOSE_PRODUCT_REVIEW_IMAGE_MODAL
);